import { lazy, Suspense } from "react"
import { Routes, Route, Outlet, useLocation } from "react-router-dom"

import NonAuthLayout from "../layouts/NonAuthLayout"
import VerticalLayout from "../layouts/index"
import { CommandPalette } from "../components/CommandPalette"

import { authProtectedRoutes, publicRoutes } from "./allRoutes"
import { AuthProtected } from "./AuthProtected"

const NotFound = lazy(() => import("../pages/NotFound"))

const PageLoader = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Cargando...</span>
    </div>
  </div>
)

// Layout persistente para rutas autenticadas: VerticalLayout (sidebar + header)
// vive UNA sola vez y los hijos cambian via <Outlet/>. Antes envolvíamos cada
// ruta con <VerticalLayout>{component}</VerticalLayout>, lo que hacía que
// react-router desmontara y volviera a montar todo el layout en cada navegación,
// reseteando el state local del sidebar (openMenus) en cada click.
const ProtectedLayout = () => {
  const { pathname } = useLocation()
  return (
    <AuthProtected>
      <VerticalLayout>
        {/* key=pathname: re-monta el contenedor en cada cambio de ruta para
            disparar la micro-transición CSS (fade+rise, ver shell-modern.css).
            La animación es solo de entrada; el contenido se re-montaba de
            todos modos al cambiar de ruta. Sin animación si el usuario pide
            prefers-reduced-motion. */}
        <div key={pathname} className="page-route-transition">
          <Outlet />
        </div>
      </VerticalLayout>
      <CommandPalette />
    </AuthProtected>
  )
}

const Index = () => {
  return (
    <Routes>
      {publicRoutes.map((route, idx) => (
        <Route
          path={route.path}
          element={<NonAuthLayout>{route.component}</NonAuthLayout>}
          key={idx}
        />
      ))}

      {/* Layout route: ProtectedLayout se monta una vez y persiste; los hijos
          cambian a través de <Outlet/>. */}
      <Route element={<ProtectedLayout />}>
        {authProtectedRoutes.map((route, idx) => (
          <Route path={route.path} element={route.component} key={idx} />
        ))}
      </Route>

      <Route
        path="*"
        element={
          <Suspense fallback={<PageLoader />}>
            <NotFound />
          </Suspense>
        }
      />
    </Routes>
  )
}

export default Index
